import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsOtherNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M7.475 1.32a.038.038 0 01.014-.015.045.045 0 01.02-.004c.01 0 .017.002.021.004a.038.038 0 01.015.014l2.894 4.341a1.292 1.292 0 002.133.024l.906-1.294a.327.327 0 01.268-.14H15V3h-1.254c-.515 0-.997.252-1.292.673l-.906 1.295a.039.039 0 01-.015.013.044.044 0 01-.02.004.045.045 0 01-.02-.004.038.038 0 01-.014-.014L8.585.626a1.292 1.292 0 00-2.161.018L5.005 2.85A.327.327 0 014.73 3H1v1.25h3.73c.537 0 1.037-.273 1.327-.724z" />
        <path d="M5.16 5.522a1.292 1.292 0 012.109.023l2.876 4.16a.039.039 0 00.014.014.045.045 0 00.02.004.044.044 0 00.02-.004.038.038 0 00.015-.014l1.305-1.992A1.577 1.577 0 0112.84 7H15v1.25h-2.162a.327.327 0 00-.273.148l-1.306 1.992a1.292 1.292 0 01-2.142.026L6.24 6.256a.038.038 0 00-.014-.014.044.044 0 00-.02-.004.044.044 0 00-.019.004.038.038 0 00-.015.013L5.2 7.598c-.297.41-.772.652-1.278.652H1V7h2.922c.105 0 .204-.05.265-.135z" />
        <path d="M5.22 10.282a.038.038 0 00-.015.014l-1.468 2.242a1.577 1.577 0 01-1.32.712H1V12h1.417c.11 0 .213-.055.274-.148l1.468-2.24a1.292 1.292 0 012.143-.027l2.885 4.172c.006.009.01.012.014.014a.044.044 0 00.02.004.044.044 0 00.019-.004.038.038 0 00.014-.012l.841-1.126A1.577 1.577 0 0111.36 12H15v1.25h-3.641c-.103 0-.2.05-.262.132l-.841 1.125a1.292 1.292 0 01-2.097-.039l-2.885-4.172a.039.039 0 00-.014-.014.045.045 0 00-.02-.004.045.045 0 00-.02.004z" />
      </g>
    </svg>
  )
);
SvgSportsOtherNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsOtherNormalXsmall;
